/**
 * TenantRadioCard - Card for tenant selection (join existing or create new) during registration.
 * MODULE: core/auth/frontend/components/TenantRadioCard.tsx
 */
import { Card } from 'flowbite-react';

export interface TenantInfo {
  id: string;
  name: string;
  domain: string;
  logo_url?: string;
}

export interface TenantRadioCardProps {
  tenant: TenantInfo;
  selected: boolean;
  onSelect: (tenantId: string) => void;
  type: 'join' | 'create';
}

export function TenantRadioCard({ tenant, selected, onSelect, type }: TenantRadioCardProps) {
  const isCreate = type === 'create';
  return (
    <Card
      className={`cursor-pointer transition-all ${
        selected ? 'ring-2 ring-blue-500 border-blue-500' : 'hover:border-gray-400'
      }`}
      onClick={() => onSelect(tenant.id)}
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center ${
            selected ? 'bg-blue-100' : 'bg-gray-100'
          }`}
        >
          {tenant.logo_url ? (
            <img src={tenant.logo_url} alt="" className="w-8 h-8 rounded-full object-cover" />
          ) : (
            <span className="text-lg font-semibold text-gray-600">
              {isCreate ? '+' : (tenant.name || '?').charAt(0).toUpperCase()}
            </span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-gray-900 truncate">
            {isCreate ? 'Create new organization' : tenant.name}
          </p>
          <p className="text-sm text-gray-500 truncate">
            {isCreate ? 'Set up a new workspace' : tenant.domain}
          </p>
        </div>
        <div
          className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
            selected ? 'border-blue-500 bg-blue-500' : 'border-gray-300'
          }`}
        >
          {selected && <span className="w-2 h-2 rounded-full bg-white" />}
        </div>
      </div>
    </Card>
  );
}
